import { Button, OptionList, Popover } from '@shopify/polaris'
import { AdjustIcon } from '@shopify/polaris-icons'
import { useCallback } from 'react'

import { useToggle } from '../common/helpers'

export type FinishedStatus = 'CANCELLED' | 'EXPIRED' | 'FAILED'

const finishedStatusLabels: Record<FinishedStatus, string> = {
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
  FAILED: 'Failed',
}

interface FinishedStatusSelectorProps {
  selectedStatuses: FinishedStatus[]
  onChange: (statuses: FinishedStatus[]) => void
}

export const FinishedStatusSelector = ({
  selectedStatuses,
  onChange,
}: FinishedStatusSelectorProps) => {
  const [active, toggleActive] = useToggle(false)

  const handleChange = useCallback(
    (selected: string[]) => {
      onChange(selected as FinishedStatus[])
    },
    [onChange]
  )

  const statusOptions = Object.entries(finishedStatusLabels).map(([value, label]) => ({
    value,
    label,
  }))

  const buttonLabel =
    selectedStatuses.length === 0
      ? 'All statuses'
      : selectedStatuses.length === 1
      ? finishedStatusLabels[selectedStatuses[0]]
      : `${selectedStatuses.length} statuses`

  const activator = (
    <Button disclosure onClick={toggleActive} icon={AdjustIcon} size="slim">
      {buttonLabel}
    </Button>
  )

  return (
    <Popover active={active} activator={activator} onClose={toggleActive}>
      <OptionList
        allowMultiple={true}
        onChange={handleChange}
        options={statusOptions}
        selected={selectedStatuses}
      />
    </Popover>
  )
}
